import { render, staticRenderFns } from "./base-card.vue?vue&type=template&id=3aa15aa3"
import script from "./base-card.vue?vue&type=script&lang=js"
export * from "./base-card.vue?vue&type=script&lang=js"
import style0 from "./base-card.vue?vue&type=style&index=0&id=3aa15aa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports